export const styles = (theme => ({
    image: {
        filter: theme.overrides.iconFilter.filter
    },
}));

